var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.pconUrl
      ? _c("div", [
          _c(
            "button",
            {
              staticClass: "single__add-to-basket-btn pcon",
              attrs: { "data-target": "#pcon", "data-toggle": "modal" }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$translate("Weberbuero::Template.pconModalButton")
                  ) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { id: "pcon-wrapper" } }, [
            _c(
              "div",
              {
                staticClass: "modal fade",
                attrs: {
                  id: "pcon",
                  tabindex: "-1",
                  role: "dialog",
                  "data-backdrop": "static",
                  "data-keyboard": "false"
                }
              },
              [
                _c("div", { staticClass: "modal-dialog" }, [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("div", { staticClass: "modal-title h3" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$translate(
                                "Weberbuero::Template.pconModalTitle"
                              )
                            ) +
                            "\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(0)
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-body" },
                      [
                        _c(
                          "client-only",
                          [
                            _c("pcon-configurator", {
                              attrs: { "item-id": _vm.currentVariation.item.id }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ]
            )
          ])
        ])
      : _c(
          "div",
          [
            _vm.currentVariation
              ? _c("add-to-basket", {
                  attrs: {
                    "variation-id": _vm.currentVariation.variation.id,
                    "is-salable":
                      !!_vm.currentVariation.filter &&
                      _vm.currentVariation.filter.isSalable,
                    "has-children":
                      !!_vm.currentVariation.filter &&
                      _vm.currentVariation.filter.hasActiveChildren,
                    "interval-quantity":
                      _vm.currentVariation.variation.intervalOrderQuantity || 1,
                    "minimum-quantity":
                      _vm.currentVariation.variation.minimumOrderQuantity,
                    "maximum-quantity":
                      !!_vm.currentVariation.variation.maximumOrderQuantity &&
                      _vm.currentVariation.variation.maximumOrderQuantity > 0
                        ? _vm.currentVariation.variation.maximumOrderQuantity
                        : null,
                    "order-properties": _vm.currentVariation.properties.filter(
                      function(prop) {
                        return prop.property.isOderProperty
                      }
                    ),
                    "has-order-properties":
                      _vm.currentVariation.hasOrderProperties,
                    "has-required-order-property":
                      _vm.currentVariation.hasRequiredOrderProperty,
                    "use-large-scale": false,
                    "show-quantity": true,
                    "item-url": _vm._f("itemURL")(_vm.currentVariation),
                    "has-price": _vm._f("hasItemDefaultPrice")(
                      _vm.currentVariation
                    ),
                    "button-size": _vm.buttonSize,
                    "padding-classes": _vm.paddingClasses,
                    "padding-inline-styles": _vm.paddingStyles,
                    "focus-select": ""
                  }
                })
              : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          "aria-label": "Close",
          "data-dismiss": "modal",
          type: "button"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }